import script from "./BulkActions.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkActions.vue?vue&type=script&setup=true&lang=js"

import "./BulkActions.vue?vue&type=style&index=0&id=70461863&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70461863"]])

export default __exports__